import { useEffect, useState } from 'react';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import UserUtils from '../../../../../helpers/UserUtils';
import If from '../../../../../helpers/If';

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: 'fit-content',
  '@media (max-width: 1200px)': {
    marginTop: '70px',
  },
}));

const Avatar = styled(AccountCircle)(({ theme }) => ({
  color: theme.palette.primary.dark,
  width: 100,
  height: 100,
}));

const Name = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const Email = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
}));

const Profile = () => {
  // Fetching user data from the Redux store
  const loggedUser = useSelector((state) => state.authentication.user);
  const [src, setSrc] = useState(UserUtils.getImageUrl(loggedUser?.id, loggedUser?.profilePhoto));

  useEffect(() => {
    const verifyImage = async () => {
      // const timestamp = new Date().getTime();   //timestamp para evitar cache no cloudfront
      // const urlWithTimestamp = `${UserUtils.getImageUrl(loggedUser?.id, loggedUser?.profilePhoto)}?ts=${timestamp}`;
      setTimeout(function() {setSrc(UserUtils.getImageUrl(loggedUser?.id, loggedUser?.profilePhoto));}, 2000);
    };
    verifyImage();
  }, [loggedUser]);

  return (
    <Root>
      <If test={!loggedUser.profilePhoto}>
        <Avatar />
      </If>
      <If test={loggedUser.profilePhoto}>
        <img
        alt='Foto Perfil'
        src={src}
        style={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          objectFit: 'cover'
          }}>
        </img>
      </If>
      <Name variant="h6">{loggedUser?.name || 'Nome não disponível'}</Name>
      <Email variant="body2">{loggedUser?.email || 'Email não disponível'}</Email>
    </Root>
  );
};

export default Profile;
